// extracted by mini-css-extract-plugin
export var block = "footer-promo-module--block--2TFJF";
export var image = "footer-promo-module--image--2VaXd";
export var content = "footer-promo-module--content--21rFz";
export var title = "footer-promo-module--title--2jsuv";
export var summary = "footer-promo-module--summary--3_kjp";